import axios from 'axios';
import notificationService from '@/services/notification.service';

const state = {
  notificationStatuses: [],
  status: {
    error: null,
    pending: false,
    resolved: false,
    rejected: false,
  },
};

const actions = {
  getNotificationStatus({ commit }, { opportunityId, notificationType }) {
    commit('GET_NOTIFICATION_STATUS');
    return notificationService.getNotificationStatus({ id: opportunityId, notificationType }).then(
      (result) => commit('GET_NOTIFICATION_STATUS_SUCCESS', result),
      (error) => {
        if (!axios.isCancel(error)) {
          commit('GET_NOTIFICATION_STATUS_ERROR', error);
        }
      },
    );
  },
};

const mutations = {
  GET_NOTIFICATION_STATUS(state) {
    state.status = {
      error: null,
      pending: true,
      resolved: false,
      rejected: false,
    };
    state.notificationStatuses = [];
  },
  GET_NOTIFICATION_STATUS_SUCCESS(state, notificationStatuses) {
    state.status = {
      ...state.status,
      pending: false,
      resolved: true,
    };
    state.notificationStatuses = notificationStatuses;
  },
  GET_NOTIFICATION_STATUS_ERROR(state, error) {
    state.status = {
      ...state.status,
      pending: false,
      rejected: true,
      error: error,
    };
  },
};

const getters = {
  notificationStatuses: (state) => state.notificationStatuses,
  error: (state) => state.status.error,
  pending: (state) => state.status.pending,
  rejected: (state) => state.status.rejected,
  resolved: (state) => state.status.resolved,
};

export const notificationStatuses = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
